import { useTranslation } from "react-i18next";
import { CheckCircle2, Circle } from "lucide-react";
import { NeuButton, NeuCard, NeuSelect } from "../../components/neu/Neu";

// Two-stage payroll posting: accrual (expense vs payable) then payment (payable vs cash).
export const PayrollPostPanel = ({ status, boxes, box, setBox, busy, onAct }) => {
  const { t } = useTranslation();
  if (!status) return null;
  const Mark = ({ done }) =>
    done ? <CheckCircle2 className="h-4 w-4 text-success" /> : <Circle className="h-4 w-4 text-muted-foreground" />;

  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <NeuCard className="grid gap-3 p-5" data-testid="pp-accrual">
        <p className="flex items-center gap-2 text-sm font-bold">
          <Mark done={status.accrual} /> {t("acct.payrollPost.accrual")}
        </p>
        <p className="text-xs text-muted-foreground">{t("acct.payrollPost.accrualHint")}</p>
        <NeuButton
          variant="primary"
          data-testid="pp-accrue"
          disabled={busy || status.accrual}
          onClick={() => onAct("accrue")}
        >
          {status.accrual ? t("acct.payrollPost.accrued") : t("acct.payrollPost.accrue")}
        </NeuButton>
      </NeuCard>

      <NeuCard className="grid gap-3 p-5" data-testid="pp-payment">
        <p className="flex items-center gap-2 text-sm font-bold">
          <Mark done={status.payment} /> {t("acct.payrollPost.payment")}
        </p>
        <p className="text-xs text-muted-foreground">{t("acct.payrollPost.paymentHint")}</p>
        <NeuSelect data-testid="pp-box" value={box} onChange={(e) => setBox(e.target.value)}>
          {boxes.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name} ({b.balance})
            </option>
          ))}
        </NeuSelect>
        <NeuButton
          variant="primary"
          data-testid="pp-pay"
          disabled={busy || !status.accrual || status.payment || !box}
          onClick={() => onAct("pay")}
        >
          {status.payment ? t("acct.payrollPost.paid") : t("acct.payrollPost.pay")}
        </NeuButton>
      </NeuCard>

      <NeuCard className="p-5 lg:col-span-2" data-testid="pp-posts">
        <p className="label-xs mb-3">{t("acct.payrollPost.entries")}</p>
        {status.posts.length === 0 ? (
          <p className="text-xs text-muted-foreground" data-testid="pp-empty">{t("acct.payrollPost.none")}</p>
        ) : null}
        <div className="grid gap-2">
          {status.posts.map((post) => (
            <div key={post.entry_number} className="flex items-center gap-3 rounded-xl px-3 py-2 shadow-neu-in">
              <span className="text-xs font-semibold">{t(`acct.payrollPost.${post.stage}`)}</span>
              <span className="min-w-0 flex-1 truncate font-mono text-[11px] text-primary" dir="ltr">
                {post.entry_number}
              </span>
              <span className="font-mono text-xs font-bold" dir="ltr">{post.amount}</span>
            </div>
          ))}
        </div>
      </NeuCard>
    </div>
  );
};
